import React, { Component } from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

export class StyledBarChart extends Component {
  render() {
    const {
      classes,
      data,
      keys,
      width,
      xAxis,
      yAxis,
      xLabel,
      yLabel,
      height,
      noLegend,
      tickFormatter,
      tooltip,
      responsive,
    } = this.props;
    if (!data) return null;
    if (responsive) {
      return (
        <ResponsiveContainer width="100%" aspect={4.0 / 1.75}>
          <BarChart data={data}>
            {xAxis || (
              <XAxis
                label={{
                  value: xLabel,
                  offset: -2,
                  position: 'insideBottom',
                }}
                padding={{ top: 10, bottom: 10 }}
                dataKey="name"
              />
            )}
            {yAxis || (
              <YAxis
                label={{
                  value: yLabel,
                  angle: -90,
                  position: 'insideLeft',
                }}
                tickFormatter={tickFormatter}
              />
            )}
            <CartesianGrid strokeDasharray="3 3" />
            {!noLegend && <Legend verticalAlign="top" />}
            <Tooltip content={tooltip} />
            {keys && keys.map(key => <Bar key={key.name} dataKey={key.name} fill={key.fill} />)}
          </BarChart>
        </ResponsiveContainer>
      );
    } else {
      return (
        <div>
          <BarChart width={width || 600} height={height || 350} data={data}>
            {xAxis || (
              <XAxis
                label={{
                  value: xLabel,
                  offset: -2,
                  position: 'insideBottom',
                }}
                padding={{ top: 10, bottom: 10 }}
                dataKey="name"
              />
            )}
            {yAxis || (
              <YAxis
                label={{
                  value: yLabel,
                  angle: -90,
                  position: 'insideLeft',
                }}
                tickFormatter={tickFormatter}
              />
            )}
            <CartesianGrid strokeDasharray="3 3" />
            {!noLegend && <Legend verticalAlign="top" />}
            <Tooltip content={tooltip} />
            {keys && keys.map(key => <Bar key={key.name} dataKey={key.name} fill={key.fill} />)}
          </BarChart>
        </div>
      );
    }
  }
}

// const styles = theme => ({
//   barchart: {
//     fontSize: 14,
//     '& .recharts-wrapper > svg.recharts-surface': {
//       padding: 10,
//     },
//   },
// });

export default StyledBarChart;
